module.exports = __webpack_public_path__ + "static/media/badge-help-left.e943961b.svg";